













































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { apiProcessApprovalSubmit, apiStaffAllList } from '@/api/work_order'

@Component
export default class ApprovalDialog extends Vue {
    @Prop({ type: Boolean, default: false }) visible!: boolean
    @Prop({ type: Object, default: () => ({}) }) workOrderData!: any

    // 表单数据
    approvalForm: any = {
      work_order_id: '',
      node_id: '',
      approval_result: 1, // 默认通过
      approval_comment: '',
      reject_reason: '',
      transfer_to_user_id: '',
      attachment_urls: [],
      signature_image: ''
    }

    // 表单验证规则
    formRules: any = {
      approval_result: [
        { required: true, message: '请选择操作', trigger: 'change' }
      ],
      approval_comment: [
        { required: true, message: '请输入审批意见', trigger: 'blur' }
      ],
      reject_reason: [
        { required: true, message: '请输入驳回原因', trigger: 'blur' }
      ],
      transfer_to_user_id: [
        { required: true, message: '请选择转交对象', trigger: 'change' }
      ]
    }

    // 可用操作列表
    availableActions: any[] = []

    // 用户列表
    userList: any[] = []

    // 文件列表
    fileList: any[] = []

    // 状态控制
    loading = false
    submitting = false

    // 签名相关
    isDrawing = false
    lastX = 0
    lastY = 0

    // 计算属性
    get showAttachment (): boolean {
      // 根据需要显示附件上传
      return false // 暂时禁用附件上传
    }

    get showSignature (): boolean {
      // 根据需要显示签名
      return false // 暂时禁用签名
    }

    // 监听工单数据变化
    @Watch('workOrderData', { immediate: true, deep: true })
    onWorkOrderDataChange (newVal: any) {
      if (newVal && newVal.id) {
        this.approvalForm.work_order_id = newVal.id
        this.approvalForm.node_id = newVal.current_node?.id || ''

        // 解析允许的操作
        this.parseAllowActions(newVal.current_node?.allow_actions)
      }
    }

    // 监听弹窗显示状态
    @Watch('visible')
    onVisibleChange (newVal: boolean) {
      if (newVal) {
        this.resetForm()
        this.getUserList()
      }
    }

    // 解析允许的操作
    parseAllowActions (allowActions: any) {
      // 如果没有allow_actions字段，默认不显示任何操作
      if (!allowActions) {
        this.availableActions = []
        console.warn('当前节点没有allow_actions字段，无法确定可用操作')
        return
      }

      try {
        // 处理不同格式的allow_actions
        let actions: any[] = []

        if (Array.isArray(allowActions)) {
          // 如果已经是数组，直接使用
          actions = allowActions
        } else if (typeof allowActions === 'string') {
          // 如果是字符串，尝试解析为JSON
          actions = JSON.parse(allowActions)
        } else {
          console.error('allow_actions类型不支持:', typeof allowActions, allowActions)
          this.availableActions = []
          return
        }

        // 确保actions是一个数组
        if (!Array.isArray(actions)) {
          console.error('allow_actions不是有效的数组:', allowActions)
          this.availableActions = []
          return
        }

        // 将字符串数字转换为数字
        const numericActions = actions.map(action => {
          if (typeof action === 'string') {
            const num = parseInt(action)
            return isNaN(num) ? action : num
          }
          return action
        })

        // 定义所有可能的操作
        const allActions = [
          { value: 1, label: '通过', disabled: !numericActions.includes(1) },
          { value: 2, label: '驳回', disabled: !numericActions.includes(2) },
          { value: 3, label: '转交', disabled: !numericActions.includes(3) },
          { value: 4, label: '撤回', disabled: !numericActions.includes(4) }
        ]

        // 只保留允许的操作
        this.availableActions = allActions.filter(action => !action.disabled)

        // 如果没有可用操作，显示警告
        if (this.availableActions.length === 0) {
          console.warn('当前节点没有允许的操作:', numericActions)
          return
        }

        // 默认选中第一个可用的操作
        this.approvalForm.approval_result = this.availableActions[0].value

        console.log('解析allow_actions成功:', numericActions, '可用操作:', this.availableActions)
      } catch (error) {
        console.error('解析allow_actions失败:', error, '原始值:', allowActions)
        this.availableActions = []
      }
    }

    // 获取审批类型标签
    getApprovalTypeLabel (actionType: number): string {
      const typeMap: any = {
        1: '审批',
        2: '执行',
        3: '验收',
        4: '付款',
        5: '报价',
        6: '派单'
      }
      return typeMap[actionType] || '-'
    }

    // 获取用户列表
    async getUserList () {
      try {
        const res = await apiStaffAllList()
        this.userList = res.lists || []
      } catch (error) {
        console.error('获取用户列表失败:', error)
      }
    }

    // 操作变化处理
    handleActionChange (value: number) {
      // 清空其他字段的验证
      this.$nextTick(() => {
        this.$refs.approvalForm && (this.$refs.approvalForm as any).clearValidate()
      })
    }

    // 文件变化处理
    handleFileChange (file: any, fileList: any[]) {
      this.fileList = fileList
    }

    // 签名相关方法
    startDrawing (e: MouseEvent) {
      this.isDrawing = true
      const canvas = this.$refs.signatureCanvas as HTMLCanvasElement
      const rect = canvas.getBoundingClientRect()
      this.lastX = e.clientX - rect.left
      this.lastY = e.clientY - rect.top
    }

    draw (e: MouseEvent) {
      if (!this.isDrawing) return

      const canvas = this.$refs.signatureCanvas as HTMLCanvasElement
      const ctx = canvas.getContext('2d')
      if (!ctx) return

      const rect = canvas.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
      ctx.lineTo(x, y)
      ctx.strokeStyle = '#000'
      ctx.lineWidth = 2
      ctx.stroke()

      this.lastX = x
      this.lastY = y
    }

    stopDrawing () {
      this.isDrawing = false
    }

    clearSignature () {
      const canvas = this.$refs.signatureCanvas as HTMLCanvasElement
      if (!canvas) return

      const ctx = canvas.getContext('2d')
      if (!ctx) return

      ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.approvalForm.signature_image = ''
    }

    // 重置表单
    resetForm () {
      this.approvalForm = {
        work_order_id: this.workOrderData?.id || '',
        node_id: this.workOrderData?.current_node?.id || '',
        approval_result: 1,
        approval_comment: '',
        reject_reason: '',
        transfer_to_user_id: '',
        attachment_urls: [],
        signature_image: ''
      }
      this.fileList = []
      // 签名功能已禁用，不调用clearSignature
      // this.clearSignature()
    }

    // 提交审批
    async handleSubmit () {
      try {
        await (this.$refs.approvalForm as any).validate()

        this.submitting = true

        // 处理附件
        if (this.fileList.length > 0) {
          // 这里应该上传文件并获取URL，暂时使用文件名
          this.approvalForm.attachment_urls = this.fileList.map(file => file.name)
        }

        // 处理签名
        // 签名功能已禁用，不处理签名
        // if (this.showSignature) {
        //     const canvas = this.$refs.signatureCanvas as HTMLCanvasElement
        //     this.approvalForm.signature_image = canvas.toDataURL()
        // }

        // 提交审批数据
        await apiProcessApprovalSubmit(this.approvalForm)

        // this.$message.success('审批提交成功')
        this.$emit('success')
        this.handleClose()
      } catch (error) {
        console.error('提交审批失败:', error)
      } finally {
        this.submitting = false
      }
    }

    // 关闭弹窗
    handleClose () {
      this.$emit('update:visible', false)
    }
}
